module.exports = __webpack_public_path__ + "static/img/office.d9f6421.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office.jpg?20181011
// module id = 4lmX
// module chunks = 1